export enum SocialProviderEnum {
  FACEBOOK = "FACEBOOK",
  GOOGLE = "GOOGLE",
  APPLE = 'APPLE'
} 
